// extracted by mini-css-extract-plugin
module.exports = {"features_swiper":"advanced_features_slide_features_swiper__lIOrJ","thumbSwiper":"advanced_features_slide_thumbSwiper__j7SaA"};